import { Field } from 'redux-form';

import AddressOnlyDisplay from 'common/components/address/AddressOnlyDisplay';
import { SelectField } from 'common/components/forms';

const PickupLocationForm = (props) => {
  const { inventoryLocation, formValues } = props;
  if (!inventoryLocation.data || !formValues.inventoryLocationId) {
    return null;
  }
  const inventoryLocationIdArray = Object.keys(inventoryLocation.data);
  if (inventoryLocationIdArray.length === 1) {
    return (
      <>
        <Field
          name="inventoryLocationId"
          component="input"
          type="hidden"
          value={inventoryLocationIdArray[0]}
        />
        <AddressOnlyDisplay
          address={inventoryLocation.data[formValues.inventoryLocationId]}
        />
      </>
    );
  }
  return (
    <>
      <Field
        name="inventoryLocationId"
        component={SelectField}
        optionArray={inventoryLocationArray(inventoryLocation)}
        label="Pickup Location"
        required
      />
      <AddressOnlyDisplay
        address={inventoryLocation.data[formValues.inventoryLocationId]}
      />
    </>
  );
};

const inventoryLocationArray = (inventoryLocation) => {
  const dataArray = Object.keys(inventoryLocation.data);
  const optionArray = dataArray.map((inventoryLocationId) => ({
    value: inventoryLocationId,
    option: inventoryLocation.data[inventoryLocationId].title
  }));
  return optionArray;
};

export default PickupLocationForm;
